module.exports = __webpack_public_path__ + "static/media/thumbnail.b2770967.jpg";